module.exports = __webpack_public_path__ + "static/media/2.296a6f4b.jpg";